"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateXlsx2CsvConfig = generateXlsx2CsvConfig;
/**
 * generate servicer report import config for (xlsx2csv node) for the given borrowing base mechanics.
 * you can use this method to auto-generate config which lists all the fields that we need to
 * import. Caller need to later substitute cellAddress and sheetName with the actual values
 */
function generateXlsx2CsvConfig({ calcAgentMechanics: _unused1, parties: _unused2, }) {
    throw new Error('This function is deprecated. xlsx2csv node is no longer used.');
}
//# sourceMappingURL=generateXlsx2CsvConfig.js.map